/**
 * @generated SignedSource<<811d285f770976cdcfc29c180e4dd862>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CreateOrganizationModalQuery$variables = Record<PropertyKey, never>;
export type CreateOrganizationModalQuery$data = {
  readonly salesforce: {
    readonly enabled: boolean;
  };
};
export type CreateOrganizationModalQuery = {
  response: CreateOrganizationModalQuery$data;
  variables: CreateOrganizationModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateOrganizationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Salesforce",
        "kind": "LinkedField",
        "name": "salesforce",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "CreateOrganizationModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Salesforce",
        "kind": "LinkedField",
        "name": "salesforce",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aff39d0854dd2f1cf6a2ae004301ee25",
    "id": null,
    "metadata": {},
    "name": "CreateOrganizationModalQuery",
    "operationKind": "query",
    "text": "query CreateOrganizationModalQuery {\n  salesforce {\n    enabled\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "da3bf627b97630621a90696a570fe922";

export default node;
